export const REMINDERS_QUERY_KEY = 'reminders'
export const MEETING_FOLLOW_UPS_QUERY_KEY = 'meeting-follow-ups'
